module.exports = __webpack_public_path__ + "media/images/loupe-21265aa900523367f4ad735ebf51b744.svg";